var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('swiper',{ref:"mainBannerSwiper",attrs:{"slides-per-view":1,"pagination":{ clickable: true },"loop":true,"autoplay":{
          delay: 4500,
          disableOnInteraction: false
        }},on:{"swiper":_vm.onSwiper,"slideChange":_vm.onSlideChange}},_vm._l((_vm.listSlides),function(slide,dataIndex){return _c('swiper-slide',{key:dataIndex},[_c('div',[_c('responsive-image',{attrs:{"title":slide.title,"images":slide.images}})],1)])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }